import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  getSalesCustomers,
  getSalesCustomerGrowers,
  getSalesCustomerProducts,
} from "../../../../redux/dispatcher/portalDispatcher";
import type { Grower, ProductData, SalesCustomer } from "../CreateSalesOder";

export const useSalesOrderLoaders = () => {
  const dispatch = useDispatch<any>();

  /** Customers where the rep is on org.sales[] */
  const loadCustomers = useCallback(
    (): Promise<SalesCustomer[]> =>
      dispatch(getSalesCustomers())
        .unwrap()
        .then((r: any) => r.data?.customers ?? []),
    [dispatch],
  );

  const loadGrowers = useCallback(
    (orgId: string): Promise<Grower[]> =>
      dispatch(getSalesCustomerGrowers(orgId))
        .unwrap()
        .then((r: any) => r.data ?? []),
    [dispatch],
  );

  /** Products; the thunk adds the State / Location filters from redux */
  const loadProducts = useCallback(
    (c: SalesCustomer): Promise<ProductData[]> =>
      c.cardCode && c.cardCode.length
        ? dispatch(
            getSalesCustomerProducts({
              organizationId: c._id,
              cardCode: c.cardCode,
            }),
          )
            .unwrap()
            .then((r: any) => r.data ?? [])
        : Promise.resolve([]), // no card code → nothing to fetch from SAP
    [dispatch],
  );

  return useMemo(
    () => ({ loadCustomers, loadGrowers, loadProducts }),
    [loadCustomers, loadGrowers, loadProducts],
  );
};
